var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoIdwell = function SvgLogoIdwell(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-width-40": 33,
    "data-width-72": 59,
    viewBox: "0 0 40 40",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.956 11.953A4.7 4.7 0 0 0 0 15.766v12.399c13.887.058 19.241-11.53 19.241-11.53s1.646-2.951 4.856-4.094c3.211-1.145 5.875.218 5.875.218 2.358.99 5.673 1.474 8.923-.017a4.8 4.8 0 0 0-.85-.789L22.772.951a4.74 4.74 0 0 0-5.543 0zm37.667 1.971-.088.06c-3.279 2.179-4.997 5.457-5.602 8.376a26 26 0 0 0-.266 1.722c-.462 3.437-1.207 8.975-6.359 11.829-6.763 3.745-13.287-1.394-13.287-1.394S8.105 29.671 0 30.369v7.174a2.394 2.394 0 0 0 2.4 2.389h35.2c1.325 0 2.4-1.07 2.4-2.389V15.765c0-.642-.132-1.267-.377-1.841M29.319 16.01c0 .734-.597 1.329-1.334 1.329a1.33 1.33 0 0 1-1.333-1.329c0-.734.597-1.329 1.333-1.329.737 0 1.334.595 1.334 1.329"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoIdwell);
export default ForwardRef;